import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

export interface GetInquirySummaryResponse {
  unreadInquiryCount: number;
  lockedInquiryCount: number;
  clientCount: number;
  clientLimit: number;
  remainingClientCount: number;
}

export const INQUIRY_SUMMARY_QUERY_KEY = ['getInquirySummary'] as const;

export const getInquirySummary = () => {
  return api.get<ApiResponse<GetInquirySummaryResponse>>(
    '/client/inquiry-summary',
  );
};

const useInquirySummary = <
  TData = AxiosResponse<ApiResponse<GetInquirySummaryResponse>>,
  TError = AxiosError<ApiErrorResponse>,
>(
  options?: UseQueryOptions<
    AxiosResponse<ApiResponse<GetInquirySummaryResponse>>,
    TError,
    TData,
    typeof INQUIRY_SUMMARY_QUERY_KEY
  >,
): UseQueryResult<TData, TError> => {
  return useQuery(INQUIRY_SUMMARY_QUERY_KEY, getInquirySummary, {
    ...options,
  });
};

export default useInquirySummary;
